import { TypePolicy } from "@apollo/client";

export default {
  keyFields: ["moduleId"],
} as TypePolicy;
